module.exports = __webpack_public_path__ + "img/t4-1.a8ef6426.svg";